import React, { useEffect, useState, Fragment } from 'react'
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, formatoMonto } from '../../../common/Formatos'
import { obtenerRutConductor, obtenerRutDestinatario } from '../../../store/actions/implicado-action'
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { getDetalles } from '../../../api/caso-general-client'

const Destinatarios = ({ formik, setRutConductorFinal, isImplicado, handleShowProp, setHandleShowProp, destinatariosPago, setDestinatariosPago }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais, comboComunas, cfg_form37, comboDestinatario, comboMedioPago, comboInstitucion, comboTipoCuenta } = data_datos_implicado

  const [tipoDestinatario, setTipoDestinatario] = useState("")
  const [rutDestinatario, setRutDestinatario] = useState('')
  const [rutDestinatarioNoFormato, setRutDestinatarioNoFormato] = useState('')
  const [nombreDestinatario, setNombreDestinatario] = useState('')
  const [emailDestinatario, setEmailDestinatario] = useState('')
  const [medioPago, setMedioPago] = useState('')
  const [institucion, setInstitucion] = useState('')
  const [tipoCuenta, setTipoCuenta] = useState('')
  const [numeroCuenta, setNumeroCuenta] = useState('')
  //viejo
  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [rutConductor, setRutConductor] = useState('')
  const [rutConductorNoFormato, setRutConductorNoFormato] = useState('')
  const [nombreConductor, setNombreConductor] = useState('')
  const [direccionConductor, setDireccionConductor] = useState('')
  const [emailConductor, setEmailConductor] = useState('')
  const [paisConductor, setPaisConductor] = useState('')
  const [paisMovilConductor, setPaisMovilConductor] = useState('')
  const [fonoConductor, setFonoConductor] = useState('')
  const [movilConductor, setMovilConductor] = useState('')
  const [comunaConductor, setComunaConductor] = useState('')
  const [ciudadConductor, setCiudadConductor] = useState('')

  const [editIndex, setEditIndex] = useState(null)
  const [errores, setErrores] = useState({})
  const [parentescos, setParentescos] = useState([])
  const [parentesco, setParentesco] = useState('')
  const [fechaNacimiento, setFechaNacimiento] = useState('')

  const ID_TIPO_DESTINATARIO_IMPLICADO = 260001;

  const convertirFecha = (fecha) => {
    if (!fecha) return ''
    const partes = fecha.split('-')
    if (partes.length !== 3) return fecha
    const [dia, mes, ano] = partes
    return [ano, mes, dia].join('-')
  }

  const fechaSiniestro = (() => {
    const fmt = antecedentesCasos?.antecedentesCasos?.[0]?.['FechaSiniestroFormat']
    return fmt ? convertirFecha(fmt) : ''
  })()

  const mostrarCamposParentesco = comboDestinatario?.comboDestinatario?.some(d =>
    String(d.id) === String(tipoDestinatario) && Number(d.agrupacion) === 310
  )

  const calcularEdad = (fechaNac, fechaSin) => {
    if (!fechaNac || !fechaSin) return ''
    const nac = new Date(fechaNac)
    const sin = new Date(fechaSin)
    if (isNaN(nac) || isNaN(sin)) return ''
    let edad = sin.getFullYear() - nac.getFullYear()
    const m = sin.getMonth() - nac.getMonth()
    if (m < 0 || (m === 0 && sin.getDate() < nac.getDate())) edad--
    return edad >= 0 ? edad : ''
  }

  const formatFechaSiniestro = (fecha) => {
    if (!fecha) return ''
    const d = new Date(fecha)
    if (isNaN(d)) return fecha
    return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`
  }

  const distpatch = useDispatch()

  useEffect(() => {
    const fetchParentescos = async () => {
      const query = Buffer.from(JSON.stringify({ concepto: 310 })).toString('base64')
      const response = await getDetalles(query)
      setParentescos(response?.detalles || [])
    }
    fetchParentescos()
  }, [])

  useEffect(() => {
    distpatch(obtenerRutDestinatario(rutDestinatarioNoFormato))
  }, [rutDestinatarioNoFormato])

  useEffect(() => {
    setRutDestinatario('');
    setRutDestinatarioNoFormato('');
    setNombreDestinatario('');
    setEmailDestinatario('');
    setMedioPago('');
    setInstitucion('');
    setTipoCuenta('');
    setNumeroCuenta('');
    setTipoDestinatario('');
    setParentesco('');
    setFechaNacimiento('');

    setHandleShowProp(false);
  }, [handleShowProp])

  useEffect(() => {
    if (!isImplicado && datosPantalla?.datosPantalla[0]) {

      setTipoDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['TipoDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['TipoDestinatario'] !== null && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== 0
          ?
          datosPantalla.datosPantalla[0]['TipoDestinatario']
          : ''
      )
      setRutDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== null
          ? formato_rut(
            datosPantalla.datosPantalla[0]['RutDestinatario'])
          : ''
      )

      setRutDestinatarioNoFormato(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['RutDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['RutDestinatario']
          : ''
      )
      setNombreDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['NombreRazonDestinatario']
          : ''
      )
      setEmailDestinatario(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['EmailDestinatario'] !== undefined &&
          datosPantalla.datosPantalla[0]['EmailDestinatario'] !== null
          ?
          datosPantalla.datosPantalla[0]['EmailDestinatario']
          : ''
      )
      setMedioPago(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['MedioPago'] !== undefined &&
          datosPantalla.datosPantalla[0]['MedioPago'] !== null && datosPantalla.datosPantalla[0]['MedioPago'] !== 0
          ?
          datosPantalla.datosPantalla[0]['MedioPago']
          : ''
      )
      setInstitucion(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== null && datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== 0
          ?
          datosPantalla.datosPantalla[0]['InstitucionFinanciera']
          : ''
      )
      setTipoCuenta(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera'] !== null && datosPantalla.datosPantalla[0]['InstitucionFinanciera'] !== 0
          ?
          datosPantalla.datosPantalla[0]['TipoCuentaFinanciera']
          : ''
      )
      setNumeroCuenta(
        datosPantalla &&
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera'] !== undefined &&
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera'] !== null
          ?
          datosPantalla.datosPantalla[0]['NroCuentaFinanciera']
          : ''
      )

      if (datosPantalla && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== undefined &&
        datosPantalla.datosPantalla[0]['TipoDestinatario'] !== null && datosPantalla.datosPantalla[0]['TipoDestinatario'] !== "" && datosPantalla.datosPantalla[0].TipoDestinatario === ID_TIPO_DESTINATARIO_IMPLICADO) {
        formik.values.rutDestinatario = datosPantalla.datosPantalla[0].RutImplicado;
        formik.values.nombreDestinatario = datosPantalla.datosPantalla[0].NombreImplicado;
        formik.values.emailDestinatario = datosPantalla.datosPantalla[0].EmailImplicado;
      }
    }


  }, [datosPantalla])

  useEffect(() => {
    if (formik.values.tipoDestinatario === ID_TIPO_DESTINATARIO_IMPLICADO || formik.values.tipoDestinatario === ID_TIPO_DESTINATARIO_IMPLICADO.toString()) {
      formik.values.rutDestinatario = formik.values.rutImplicado;
      formik.values.nombreDestinatario = formik.values.nombreImplicado;
      formik.values.emailDestinatario = formik.values.emailImplicado;
    }
  }, [formik.values.rutImplicado, formik.values.nombreImplicado, formik.values.emailImplicado])

  const existeRut = (rut) => {
    return destinatariosPago.some((d, index) => {
      if (editIndex !== null && index === editIndex) return false
      return d.rutDestinatario == rut
    })
  }
  const handleAgregarOEditar = () => {
      const erroresValidados = validarDestinatario()

      if (Object.keys(erroresValidados).length > 0) {
        setErrores(erroresValidados)
        return
      }

      setErrores({}) 

      const nuevo = {
        tipoDestinatario,
        rutDestinatario,
        nombreDestinatario,
        emailDestinatario,
        medioPago,
        institucion,
        tipoCuenta,
        numeroCuenta,
        parentesco: mostrarCamposParentesco ? parentesco : '',
        fechaNacimiento: mostrarCamposParentesco ? fechaNacimiento : '',
        edad: mostrarCamposParentesco ? calcularEdad(fechaNacimiento, fechaSiniestro) : null
      }

      if (editIndex !== null) {
        const copia = [...destinatariosPago]
        copia[editIndex] = nuevo
        setDestinatariosPago(copia)
        setEditIndex(null)
      } else {
        setDestinatariosPago([...destinatariosPago, nuevo])
      }

      limpiarFormulario();
      setTipoDestinatario("");
    }
    const handleEditar = (row, index) => {
      setEditIndex(index)

      setTipoDestinatario(row.tipoDestinatario)
      setRutDestinatario(row.rutDestinatario)
      setNombreDestinatario(row.nombreDestinatario)
      setEmailDestinatario(row.emailDestinatario)
      setMedioPago(row.medioPago)
      setInstitucion(row.institucion)
      setTipoCuenta(row.tipoCuenta)
      setNumeroCuenta(row.numeroCuenta)
      setParentesco(row.parentesco || '')
      setFechaNacimiento(row.fechaNacimiento ? row.fechaNacimiento.substring(0, 10) : '')
    }
    const handleEliminar = (index) => {
      const copia = destinatariosPago.filter((_, i) => i !== index)
      setDestinatariosPago(copia)
    }
    const limpiarFormulario = () => {
     
      setRutDestinatario("")
      setRutDestinatarioNoFormato("")
      setNombreDestinatario("")
      setEmailDestinatario("")
      setMedioPago("")
      setInstitucion("")
      setTipoCuenta("")
      setNumeroCuenta("")
      setParentesco("")
      setFechaNacimiento("")
      setErrores("")
    }
    
    const validarDestinatario = () => {
      const errores = {}

      if (!tipoDestinatario) {
        errores.tipoDestinatario = 'Seleccione tipo destinatario'
      }
      if (!rutDestinatario) {
        errores.rutDestinatario = 'Ingrese RUT'
      }
      if (!nombreDestinatario) {
        errores.nombreDestinatario = 'Ingrese nombre'
      }
      if (emailDestinatario) {
        const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailDestinatario)
        if (!emailValido) {
          errores.emailDestinatario = 'Email inválido'
        }
      }
      const { rutDuplicado, tipoDuplicado } = existeDuplicado(
        rutDestinatario,
        tipoDestinatario,
        editIndex
      );

      if (rutDuplicado) {
        errores.rutDestinatario = 'RUT ya agregado.';
      }

      if (tipoDuplicado) {
        errores.tipoDestinatario = 'Tipo destinatario ya agregado.';
      }
      if (mostrarCamposParentesco && fechaNacimiento && fechaSiniestro &&
          new Date(fechaNacimiento) > new Date(fechaSiniestro)) {
        errores.fechaNacimiento = `Fecha de nacimiento no puede ser posterior a Fecha de Siniestro (${formatFechaSiniestro(fechaSiniestro)})`
      }
      return errores
    }
    const existeDuplicado = (rut, tipoDestinatario, editIndex = null) => {

      let rutDuplicado = false;
      let tipoDuplicado = false;

      destinatariosPago.forEach((d, index) => {

        if (editIndex !== null && index === editIndex) return;

        if (d.rutDestinatario == rut) {
          rutDuplicado = true;
        }

        if (d.tipoDestinatario == tipoDestinatario) {
          tipoDuplicado = true;
        }
      });

      return { rutDuplicado, tipoDuplicado };
    };
    const getNombreDestinatario = (id) => {
      return comboDestinatario?.comboDestinatario?.find(
        c => String(c.id) === String(id)
      )?.nombre || id
    }
  return (
    <Fragment>
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form37
            ? cfg_form37.cfg_form37[
            'casograldefensa-editimpl-title-dest-pago'
            ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form37 ? (
            <div>
              <Row>

                <Col>
                  <Form.Label className=' mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-tipodest']}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setTipoDestinatario(e.target.value)
                      limpiarFormulario()
                      if (e.target.value !== ID_TIPO_DESTINATARIO_IMPLICADO.toString()) {
                        setRutDestinatario("")
                        setNombreDestinatario("")
                        setEmailDestinatario("")
                        setRutDestinatarioNoFormato("")
                      } else {
                        setRutDestinatario(formik.values.rutImplicado)
                        setNombreDestinatario(formik.values.nombreImplicado)
                        setEmailDestinatario(formik.values.emailImplicado)
                      }
                      setErrores(prev => ({
                        ...prev,
                        tipoDestinatario: null
                      }))
                    }}
                    name='tipoDestinatario'
                    value={(formik.values.tipoDestinatario = tipoDestinatario)}
                    error={formik.errors.tipoDestinatario}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboDestinatario &&
                      comboDestinatario.comboDestinatario?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.tipoDestinatario ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoDestinatario}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  {errores.tipoDestinatario && (
                    <Form.Text style={{ color: 'red' }}>
                      {errores.tipoDestinatario}
                    </Form.Text>
                  )}
                </Col>
                <Col>
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-rutdest']}
                  </Form.Label>{' '}
                  <br/>
                  {!isImplicado && formik.values.tipoDestinatario == ID_TIPO_DESTINATARIO_IMPLICADO.toString() ?
                    <div>
                      <Form.Text className='mb-3'>
                        {formik.values.rutImplicado && formik.values.rutImplicado !== 'undefined' ? formik.values.rutImplicado : ''}
                      </Form.Text> 
                      {errores.rutDestinatario && (
                          <Form.Text style={{ color: 'red' }}>
                            {errores.rutDestinatario}
                          </Form.Text>
                        )}
                    </div>
                      :
                    isImplicado && formik.values.tipoDestinatario == ID_TIPO_DESTINATARIO_IMPLICADO.toString() ?
                      <Form.Text className='mb-3'>
                        {formik.values.rutImplicadoTercero && formik.values.rutImplicadoTercero !== 'undefined' ? formik.values.rutImplicadoTercero : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          autoComplete='off'
                          value={
                            (formik.values.rutDestinatario =
                              rutDestinatario !== undefined && rutDestinatario)
                          }
                          onChange={(e) => {
                            formik.handleChange(e)
                            setRutDestinatario(e.target.value)
                            setRutDestinatarioNoFormato(e.target.value)
                            setErrores(prev => ({
                              ...prev,
                              rutDestinatario: null
                            }))
                          }}
                          onFocus={() =>
                            setRutDestinatario(rutDestinatarioNoFormato)
                          }
                          onBlur={() => {
                            setRutDestinatario(formato_rut(rutDestinatario))
                          }}
                          name='rutDestinatario'
                          error={formik.errors.rutDestinatario}
                        ></Form.Control>
                        {formik.errors.rutDestinatario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.rutDestinatario}
                          </Form.Text>
                        ) : ('')}
                        {errores.rutDestinatario && (
                          <Form.Text style={{ color: 'red' }}>
                            {errores.rutDestinatario}
                          </Form.Text>
                        )}
                      </>
                  }
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-nomdest'
                      ]
                    }
                  </Form.Label>
                  <br />

                  {!isImplicado && formik.values.tipoDestinatario == ID_TIPO_DESTINATARIO_IMPLICADO.toString() ?
                    <Form.Text className='mb-3'>
                      {formik.values.nombreImplicado && formik.values.nombreImplicado !== 'undefined' ? formik.values.nombreImplicado : ''}
                    </Form.Text> :
                    isImplicado && formik.values.tipoDestinatario == ID_TIPO_DESTINATARIO_IMPLICADO.toString() ?
                      <Form.Text className='mb-3'>
                        {formik.values.nombreInvolucradoTercero && formik.values.nombreInvolucradoTercero !== 'undefined' ? formik.values.nombreInvolucradoTercero : ''}
                      </Form.Text> :
                      <>
                        <Form.Control
                          className='mt-2 w-75'
                          value={
                            (formik.values.nombreDestinatario =
                              nombreDestinatario !== undefined && nombreDestinatario)
                          }
                          onChange={(e) => {
                            formik.handleChange(e)
                            setNombreDestinatario(e.target.value)
                            setErrores(prev => ({
                              ...prev,
                              nombreDestinatario: null
                            }))
                          }}
                          name='nombreDestinatario'
                          error={formik.errors.nombreDestinatario}
                        ></Form.Control>
                        {formik.errors.nombreDestinatario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.nombreDestinatario}
                          </Form.Text>
                        ) : ('')}                  
                        {errores.nombreDestinatario && (
                          <Form.Text style={{ color: 'red' }}>
                            {errores.nombreDestinatario}
                          </Form.Text>
                        )}
                      </>
                  }
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-emaildest'
                      ]
                    }
                  </Form.Label>
                  <br />

                  {formik.values.tipoDestinatario == ID_TIPO_DESTINATARIO_IMPLICADO.toString() ?
                    <Form.Text className='mb-3'>
                      {formik.values.emailImplicado && formik.values.emailImplicado !== 'undefined' ? formik.values.emailImplicado : ''}
                    </Form.Text> :
                    <>
                      <Form.Control
                        className='mt-2'
                        value={
                          (formik.values.emailDestinatario =
                            emailDestinatario !== undefined && emailDestinatario)
                        }
                        onChange={(e) => {
                          formik.handleChange(e)
                          setEmailDestinatario(e.target.value)
                          setErrores(prev => ({
                            ...prev,
                            emailDestinatario: null
                          }))
                        }}
                        name='emailDestinatario'
                        error={formik.errors.emailDestinatario}
                      ></Form.Control>
                      {formik.errors.emailDestinatario ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.emailDestinatario}
                        </Form.Text>
                      ) : ('')}
                      {errores.emailDestinatario && (
                        <Form.Text style={{ color: 'red' }}>
                          {errores.emailDestinatario}
                        </Form.Text>
                      )}
                    </>
                  }
                </Col>
              </Row>
              {mostrarCamposParentesco && (
                <Row>
                  <Col md='3'>
                    <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {cfg_form37.cfg_form37['casograldefensa-editimpl-parentesco']}
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2 w-75'
                      value={parentesco}
                      onChange={(e) => setParentesco(e.target.value)}>
                      <option value=''>Seleccione...</option>
                      {parentescos.map(p => (
                        <option key={p.id} value={p.id}>{p.nombre}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md='3'>
                    <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {cfg_form37.cfg_form37['casograldefensa-editimpl-fechanac']}
                    </Form.Label>
                    <br />
                    <Form.Control
                      className='mt-2 w-75'
                      type='date'
                      value={fechaNacimiento}
                      onChange={(e) => {
                        const val = e.target.value
                        setFechaNacimiento(val)
                        if (val && fechaSiniestro && new Date(val) > new Date(fechaSiniestro)) {
                          setErrores(prev => ({ ...prev, fechaNacimiento: `Fecha de nacimiento no puede ser posterior a Fecha de Siniestro (${formatFechaSiniestro(fechaSiniestro)})` }))
                        } else {
                          setErrores(prev => ({ ...prev, fechaNacimiento: null }))
                        }
                      }}
                    />
                    {errores.fechaNacimiento && (
                      <Form.Text style={{ color: 'red' }}>{errores.fechaNacimiento}</Form.Text>
                    )}
                  </Col>
                  <Col md='2'>
                    <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {cfg_form37.cfg_form37['casograldefensa-editimpl-edad']}
                    </Form.Label>
                    <br />
                    <Form.Control
                      className='mt-2 w-75'
                      readOnly
                      value={calcularEdad(fechaNacimiento, fechaSiniestro)}
                      style={{ backgroundColor: '#e9ecef', cursor: 'default' }}
                    />
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-mediopagodest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setMedioPago(e.target.value)
                      setErrores(prev => ({
                        ...prev,
                        medioPago: null
                      }))
                    }}
                    name='medioPago'
                    value={(formik.values.medioPago = medioPago)}
                    error={formik.errors.medioPago}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboMedioPago &&
                      comboMedioPago.comboMedioPago?.filter(m => m.agrupacion === 1).map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.medioPago ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.medioPago}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  {errores.medioPago && (
                    <Form.Text style={{ color: 'red' }}>
                      {errores.medioPago}
                    </Form.Text>
                  )}
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-instfinandest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setInstitucion(e.target.value)
                      setErrores(prev => ({
                        ...prev,
                        institucion: null
                      }))
                    }}
                    name='institucion'
                    value={(formik.values.institucion = institucion)}
                    error={formik.errors.institucion}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboInstitucion &&
                      comboInstitucion.comboInstitucion?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.institucion ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.institucion}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  {errores.institucion && (
                    <Form.Text style={{ color: 'red' }}>
                      {errores.institucion}
                    </Form.Text>
                  )}
                </Col>

                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-tipoctadest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setTipoCuenta(e.target.value)
                      setErrores(prev => ({
                        ...prev,
                        tipoCuenta: null
                      }))
                    }}
                    name='tipoCuenta'
                    value={(formik.values.tipoCuenta = tipoCuenta)}
                    error={formik.errors.tipoCuenta}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboTipoCuenta &&
                      comboTipoCuenta.comboTipoCuenta?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.tipoCuenta ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoCuenta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  {errores.tipoCuenta && (
                    <Form.Text style={{ color: 'red' }}>
                      {errores.tipoCuenta}
                    </Form.Text>
                  )}
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form37.cfg_form37[
                      'casograldefensa-editimpl-nroctadest'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2 w-75'
                    autoComplete='off'
                    value={
                      (formik.values.numeroCuenta =
                        numeroCuenta !== undefined && numeroCuenta)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setNumeroCuenta(e.target.value)
                      setErrores(prev => ({
                        ...prev,
                        numeroCuenta: null
                      }))  
                    }}

                    name='numeroCuenta'
                    error={formik.errors.numeroCuenta}
                  ></Form.Control>
                  {formik.errors.numeroCuenta ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.numeroCuenta}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                  {errores.numeroCuenta && (
                    <Form.Text style={{ color: 'red' }}>
                      {errores.numeroCuenta}
                    </Form.Text>
                  )}
                </Col>
              </Row>
              <Row className='mt-3'>
                <Col className='d-flex justify-content-end gap-2'>
                  {editIndex !== null && (
                    <Button size='sm' variant='outline-secondary' onClick={() => { limpiarFormulario(); setTipoDestinatario(""); setEditIndex(null); }}>
                      Cancelar
                    </Button>
                  )}
                  <Button
                    size='sm'
                    variant={editIndex !== null ? 'outline-success' : 'outline-primary'}
                    onClick={handleAgregarOEditar}
                  >
                    {editIndex !== null ? 'Actualizar destinatario' : 'Agregar destinatario'}
                  </Button>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <Table striped hover className="table destinatarios-table">
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Rut</th>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Monto</th>
                        <th style={{ textAlign: 'center', width: '8%' }}>Acciones</th>
                      </tr>
                    </thead>

                    <tbody>
                      {destinatariosPago.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            Sin destinatarios
                          </td>
                        </tr>
                      ) : (
                        destinatariosPago.map((row, index) => (
                          <tr key={index}>
                            <td>{getNombreDestinatario(row.tipoDestinatario)}</td>
                            <td>{row.rutDestinatario}</td>
                            <td>{row.nombreDestinatario}</td>
                            <td>{row.emailDestinatario}</td>
                            <td>{formatoMonto(row.montoPago)}</td> 

                            <td className="text-center">                              
                              <FaEdit className='icon'
                                  size={20}
                                  color='gray'
                                  title="Modificar Destinatario"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleEditar(row, index)}
                              />
                              <FaTrashAlt className='icon'
                                  size={20}
                                  color='gray'
                                  title="Eliminar Destinatario"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleEliminar(index)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          ) : null}
        </Container>
      </Card>
      <style type='text/css'>
          {`             
              .destinatarios-table thead th {
                  background-color: #4F517A;
                  color: white;
              }
          `}
      </style>
  </Fragment>
  )
}
export default Destinatarios
